import React, { useCallback, useEffect, useRef, useState } from "react"
import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import ToolbarButton from "./ToolbarButton"

export const SHOW_TO_STUDENT_TEXTS = {
    show: "Afficher à l'élève",
    shown: "Affichée chez l'élève ✓",
    alreadyShown: "L'élève l'a déjà devant lui.",
}

// The tutor's "Afficher à l'élève", read on what the student really has in
// front of them (`useSeenStudentActivity`), Wajih, 27/10: the button stays
// offered (it brings back an activity hidden under the video), but on the
// activity already in front of the student it says so instead of sending
// again, and a doubting tutor no longer re-asks "interrompre Sam ?".
export const isShownToStudent = (seenActivityId, activityId) =>
    seenActivityId != null && seenActivityId === activityId

/** Without an answer from the student, the loader gives up after this. */
export const SHOW_TO_STUDENT_TIMEOUT_MS = 5000

// The loader after a press: it stops as soon as the student has the activity
// in front of them (the button then confirms it), or after the timeout.
export function useShowToStudentLoading(seenActivityId, activityId) {
    const [loading, setLoading] = useState(false)
    const timer = useRef(null)
    const stop = useCallback(() => {
        if (timer.current) clearTimeout(timer.current)
        timer.current = null
        setLoading(false)
    }, [])
    const start = useCallback(() => {
        if (timer.current) clearTimeout(timer.current)
        setLoading(true)
        timer.current = setTimeout(stop, SHOW_TO_STUDENT_TIMEOUT_MS)
    }, [stop])
    const shown = isShownToStudent(seenActivityId, activityId)
    useEffect(() => {
        if (loading && shown) stop()
    }, [loading, shown, stop])
    useEffect(() => () => timer.current && clearTimeout(timer.current), [])
    return { loading, start, stop }
}

const ShowToStudentButton = ({
    seenActivityId,
    activityId,
    loading,
    onShow,
    style,
}) => {
    // Sent and waiting: the loader until the student has it in front of them,
    // then the confirmation.
    if (!loading && isShownToStudent(seenActivityId, activityId)) {
        return (
            <ToolbarButton
                icon="eye"
                label={SHOW_TO_STUDENT_TEXTS.shown}
                onPress={() =>
                    SnackBarM.show({
                        text1: SHOW_TO_STUDENT_TEXTS.alreadyShown,
                        duration: 3000,
                    })
                }
                style={style}
            />
        )
    }
    return (
        <ToolbarButton
            icon="bullseye"
            label={SHOW_TO_STUDENT_TEXTS.show}
            onPress={onShow}
            loading={loading}
            style={style}
        />
    )
}

export default ShowToStudentButton
